/* document.addEventListener("DOMContentLoaded", () => {

  const targetNode = document.querySelector('#cart-subtotal'); // Adjust the selector based on your DOM
  const config = { childList: true, subtree: true };

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        //checkCartTotal();
      }
    });
  });

  // Start observing the cart subtotal
  if (targetNode) {
    observer.observe(targetNode, config);
  } else {
    console.error('Target node for MutationObserver not found!');
  }



    // Select the cart drawer element
    const cartDrawer = document.querySelector('.cart-drawer'); // Update selector as needed
    const body = document.body;

    // Function to add/remove class based on drawer state
    function toggleCartClass(isOpen) {
        if (isOpen) {
            body.classList.add('cart_drawer_opened');
        } else {
            body.classList.remove('cart_drawer_opened');
        }
    }

    // Event listener for opening the cart drawer
    document.querySelector('.open-cart-button').addEventListener('click', function () {
        toggleCartClass(true);
    });

    // Event listener for closing the cart drawer
    document.querySelector('.cart__drawer-header-close').addEventListener('click', function () {
        toggleCartClass(false);
    });


}); */

const strikeThroughPriceElements = document.querySelectorAll(".ctm-strike-through_price");

if (strikeThroughPriceElements.length > 0) {
    // Function to clean the text content
    const cleanTextContent = (element) => {
        if (element.textContent.startsWith("- ")) {
            element.textContent = element.textContent.replace(/^- /, '');
        }
    };


    strikeThroughPriceElements.forEach((element) => cleanTextContent(element));

    const observer = new MutationObserver(() => {
        document.querySelectorAll(".ctm-strike-through_price").forEach((element) => cleanTextContent(element));
    });

    strikeThroughPriceElements.forEach((element) => {
        observer.observe(element, {
            characterData: true,
            subtree: true,
            childList: true,
        });
    });

    const parentObserver = new MutationObserver(() => {
        document.querySelectorAll(".ctm-strike-through_price").forEach((element) => {
            if (!element._observed) {
                element._observed = true;
                cleanTextContent(element);
                observer.observe(element, {
                    characterData: true,
                    subtree: true,
                    childList: true,
                });
            }
        });
    });

    parentObserver.observe(document.body, {
        childList: true,
        subtree: true,
    });
}



// stopPropagation on .cart__drawer was blocking touchmove/pointermove from
// reaching document, where Swiper v11 registers its move listeners after the
// first touch. Exempt the upsell swiper so Swiper can track horizontal drags.
document.querySelector('.cart__drawer').addEventListener('touchmove', function (event) {
    if (event.target.closest('.upsell-swiper')) return;
    event.stopPropagation();
}, { passive: false });


document.addEventListener("DOMContentLoaded", function () {

  var swiperContainer_nav = document.querySelector(".ctm_nav_upsell_main");

    if (!swiperContainer_nav) return;

    var swiper_nav = new Swiper(swiperContainer_nav, {
      slidesPerView: 2.5, // Default setting
      spaceBetween: 20,
      navigation: {
        nextEl: ".remedy_nav_next",
        prevEl: ".remedy_nav_prev",
      },
      breakpoints: {
        1024: {
          slidesPerView: 5.5,
        },
        768: {
          slidesPerView: 3,
        },
        480: {
          slidesPerView: 1,
        },
      },
      on: {
        resize: function () {
          if (swiper_nav) swiper_nav.update(); // Force Swiper to recalculate slides
        },
      },
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const accordionTitles = document.querySelectorAll('.main_ctm_child_link');
  // const elementParent = document.querySelector('#shop-by-steps');

  accordionTitles.forEach((titleEl) => {
    titleEl.addEventListener('click', function () {

      const contentEl = titleEl.nextElementSibling;
      const isOpen = contentEl.classList.contains('open');

      document.querySelectorAll('.main_accordion_content').forEach((panel) => {
        panel.classList.remove('open');
        panel.style.maxHeight = '0px';
      });

      accordionTitles.forEach((el) => el.classList.remove('active'));

      if (!isOpen) {
        contentEl.classList.add('open');
        contentEl.style.maxHeight = contentEl.scrollHeight + 'px';
        titleEl.classList.add('active');
        console.log(`Opened: ${titleEl.textContent.trim()}`);
      } else {
        console.log(`Closed: ${titleEl.textContent.trim()}`);
      }
    });
  });

  /*
  elementParent.addEventListener('click', function (event) {
    if (!event.target.closest('.main_ctm_child_link')) {
      // console.log('Clicked on parent element (not on child)');
      const target = event.currentTarget.querySelectorAll('.main_ctm_child_link');
      if (target.length > 0 && !target[0].classList.contains('active')) {
        target[0].click();
      }
    }
  });
  */

  const handleMenuActive = () => {
    const mobileMenu = document.querySelector("#mobile-ecom-menu");
    if (mobileMenu) {
      const li = mobileMenu.querySelectorAll("li");
      const secondli = mobileMenu.querySelector("#shop-by-steps");
      
      if (li?.length) {
        // The first link is set to active/open by default, the following ones are disabled/closed
        li.forEach((ele, index) => {
          const panel = ele.querySelector(".ac-panel");
          if (index > 0) {
            if (panel) panel.style.height = 0;
            ele.classList.remove("is-active");
            ele.classList.remove("ac--open");
          } else {
            if (panel) panel.style.height = 'auto';
            ele.classList.add("is-active");
            ele.classList.add("ac--open");
          }
        });
      }

      if (secondli) {
        // First childlink is open by default.
        const childLinkHeader = secondli.querySelectorAll('.main_ctm_child_link');
        if (childLinkHeader.length > 0 && !childLinkHeader[0].classList.contains('active')) {
          childLinkHeader[0].click();
        }

        // A css variable is stored in each panel for animation purposes.
        const panels = secondli.querySelectorAll(".main_accordion_content");
        if (panels.length) {
          panels.forEach((panel) => {
            panel.style.setProperty('--ac-content-height', `${panel.scrollHeight}px`);
          });
        }
      }
    } 
  };

  window.addEventListener("load", () => {
    handleMenuActive();
  });

  const hamburger = document.getElementById("hamburger");
  if (hamburger) {
    hamburger.addEventListener("click", () => {
      handleMenuActive();
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const navTab = document.querySelector("nav.header__ecom-menus");

  if (navTab) {
    document.querySelectorAll('a[data-child-menu]').forEach(link => {
      link.addEventListener("mouseenter", function () {
        const menuValue = this.getAttribute("data-child-menu");
        const matchingMenu = document.querySelector(`ul[data-child-menu="${menuValue}"]`);

        document.querySelectorAll('a[data-child-menu]').forEach(otherLink => {
          if (otherLink !== this) {
            otherLink.classList.remove("after:bg-navy");
          }
        });

        this.classList.add("after:bg-navy");

        navTab.classList.remove("invisible");

        if (!matchingMenu) {
          navTab.classList.add("invisible");
        }
      });

      link.addEventListener("mouseleave", function () {
        this.classList.remove("after:bg-navy");
      });
    });
  }
});
document.addEventListener("DOMContentLoaded", () => {
    const popup = document.querySelector(".popup-wrap");
    const overlay = popup?.querySelector(".popup-overlay");
    const keepShoppingBtn = popup?.querySelector(".cart-popup-keep-shopping");

    if (!popup) {
        console.warn("Cart popup not found on page.");
        return;
    }

    // Manual close handlers
    overlay?.addEventListener("click", () => popup.classList.remove("active"));
    keepShoppingBtn?.addEventListener("click", () => popup.classList.remove("active"));

    document.body.addEventListener("click", function(e) {
        const btn = e.target.closest(".vw--icon-button[data-videowise-variant-id]");
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        const variantId = btn.getAttribute("data-videowise-variant-id");
        if (!variantId) {
            console.warn("Variant ID not found for clicked button.");
            return;
        }

        if (!window.liquidAjaxCart?.add) {
            console.error("Liquid Ajax Cart is not initialized yet.");
            return;
        }

        // Disable button temporarily
        if (btn.disabled) return;
        btn.disabled = true;

        const formData = new FormData();
        formData.set("id", variantId);
        formData.set("quantity", "1");

        // Add item via Liquid Ajax Cart
        window.liquidAjaxCart.add(formData, {
          headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Content-Type': 'application/json'
            },
            lastCallback: ({ responseData, requestState }) => {
                // Re-enable button
                btn.disabled = false;

                if (!responseData?.ok) {
                    console.error("Failed to add item to cart:", responseData);
                    return;
                }

                const cart = requestState.responseData.body;

                if (!cart?.items || cart.items.length === 0) {
                    console.warn("Cart is empty after adding item.");
                    return;
                }

                const lastItem = cart.items[cart.items.length - 1];

                // Update popup immediately with real data
                const image = popup.querySelector(".cart-popup-product-image");
                const title = popup.querySelector(".cart-popup-product-title");
                const options = popup.querySelector(".cart-popup-product-options");
                const price = popup.querySelector(".cart-popup-product-price .final-price");
                const original = popup.querySelector(".cart-popup-product-price .original-price");
                const subtotal = popup.querySelector(".cart-popup-subtotal");
                const link = popup.querySelector(".cart-popup-product-link");

                if (image) {
                    image.src = lastItem.image;
                    image.alt = lastItem.product_title;
                }

                if (title) title.textContent = lastItem.product_title;
                if (link) link.href = lastItem.url;

                if (options)
                    options.textContent =
                        lastItem.variant_title && lastItem.variant_title !== "Default Title"
                            ? lastItem.variant_title
                            : "";

                if (price) price.textContent = "PKR " + (lastItem.price / 100).toLocaleString();
                if (original)
                    original.textContent = lastItem.compare_at_price
                        ? "PKR " + (lastItem.compare_at_price / 100).toLocaleString()
                        : "";

                if (subtotal)
                    subtotal.textContent = "PKR " + (cart.total_price / 100).toLocaleString();
            }
        });
    }, true);
});